"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var SidekickEventTypes = {
  EMAIL_OPEN: 'emailOpen',
  EMAIL_CLICK: 'emailClick',
  EMAIL_TRACKER_CREATE: 'emailSent'
};
var _default = SidekickEventTypes;
exports.default = _default;
module.exports = exports.default;